var AppContactDetailsComponent = (function () {
    function AppContactDetailsComponent() {
    }
    AppContactDetailsComponent.prototype.validPhoneNumber = function (number, type) {
        if (number.length <= 0) {
            return true;
        }
        if (type === 'mobile') {
            return number === undefined || number === null || number.length === 0 || /^07\d{9}$/.test(number);
        }
        else if (type === 'landline') {
            return number === undefined || number === null || number.length === 0 || /^0[12]\d{8,9}$/.test(number);
        }
        else {
            return true;
        }
    };
    return AppContactDetailsComponent;
}());
export { AppContactDetailsComponent };



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/contact-details/app-contact-details.component.ts.pre-build-optimizer.js